var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "CardBodyItem",
    {
      attrs: {
        label: "Groups",
        labelDivClass: "labelDivWidth self-start mt-1 items-center",
        customAlign: _vm.alignment,
        itemExtraInfo: _vm.teams.length,
      },
    },
    [
      _c("GroupChips", {
        attrs: {
          groups: _vm.groups,
          navigateTo: { name: _vm.routeNames.MANAGE_TEAMS },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }